module.exports = __webpack_public_path__ + "img/ic_file_setting_1.9de0bdc6.svg";